import { render, staticRenderFns } from "./ShopnumberConfig.vue?vue&type=template&id=298d65a3&scoped=true"
import script from "./ShopnumberConfig.vue?vue&type=script&lang=js"
export * from "./ShopnumberConfig.vue?vue&type=script&lang=js"
import style0 from "./ShopnumberConfig.vue?vue&type=style&index=0&id=298d65a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298d65a3",
  null
  
)

export default component.exports